export default "__VITE_ASSET__CxFDLwDE__"